import {
    GET_EQUITY_DETAILS_SUCCESS,
    GET_EQUITY_DETAILS_FAILURE,
    EQUITY_USAGE_ATTACHMENT_UPLOAD_FAILURE,
    EQUITY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
    EQUITY_DELETE_ATTACHMENT_REQUEST_FAILURE,
    EQUITY_GET_IMAGE_PO_PREVIEW_SUCCESS,
    EQUITY_GET_IMAGE_PO_PREVIEW_FAILURE,
} from '../actions/actionTypes';

import {
    setPOTissueImageDetails,
    setPONonTissueImageDetails,
    setShippingDetails,
} from '../actions';

import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { convertObjectToQueryParams, setMyCaseRef } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';


const usageAttachmentUploadEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/attachment`;

const deleteAttachmentEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/removeAttachment?fileName=${fileName}`;

const getImagePoPreviewEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/attachment?attachmentName=${fileName}`;

const usageAttachmentUploadFunc = async (obj) => {
    try {
        const response = await axios.post(usageAttachmentUploadEndpoint(), obj);

        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: usageAttachmentUploadEndpoint(),
        });
        return {};
    }
};

const deleteAttachmentFunc = async (obj) => {
    try {
        const response = await axios.delete(
            deleteAttachmentEndpoint(obj.fileName),
            obj
        );
        return response ? response : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: deleteAttachmentEndpoint(obj.fileName),
            requestPayload: obj,
        });
        return {};
    }
};
const getImagePoPreviewFunc = async (obj) => {
    try {
        const response = await axios.get(
            getImagePoPreviewEndpoint(obj.fileName)
        );
        return response ? response : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: getImagePoPreviewEndpoint(obj.fileName),
        });
        return {};
    }
};
export function* getEquityDetailsSaga(action) {
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    const params = convertObjectToQueryParams(action.payload);

    url += `/order/equity?${params}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        // console.log('result1', result);
        setMyCaseRef(result?.myCASERef);
        yield put({
            type: GET_EQUITY_DETAILS_SUCCESS,
            myCaseRef: result.myCASERef,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            // loadAll: value?.isLoadAll,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_EQUITY_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export const getAttachmentPromise = (attachmentObj, myCaseRef, salesOrg) => {
    const formData = new FormData();
    formData.append('poUploadedFile', attachmentObj, attachmentObj.name);
    formData.append('myCaseRef', myCaseRef);
    formData.append('salesOrg', salesOrg);
    return usageAttachmentUploadFunc(formData);
};

export function* usageAttachmentUploadSaga(action) {
    // const { existingTissueImages, existingNonTissueImages } = yield select(
    //     (state) => ({
    //         existingTissueImages:
    //             state.equityDetailsReducer?.poTissueImageDetails,
    //         existingNonTissueImages:
    //             state.equityDetailsReducer?.poNonTissueImageDetails,
    //     })
    // );
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.equityReducer.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                ].payment.poAttachment,
            existingNonTissueImages:
                state.equityReducer.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                ].payment.poAttachment,
        })
    );
    try {
        const promiseArray = [];
        const { files, tissue, nonTissue, myCaseRef } = action.payload;
       [...(files || [])].forEach((file) => {
            if (tissue && nonTissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030'),
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            } else if (tissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030')
                );
            } else {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            }
        });

        const responses = yield Promise.all(promiseArray);
        const tissueFiles = [];
        const nonTissueFiles = [];
        responses.forEach((response) => {
            if (response?.fileName?.includes('_S030_')) {
                tissueFiles.push(response.fileName);
            } else if (response?.fileName?.includes('_S002_')) {
                nonTissueFiles.push(response.fileName);
            }
        });

        if (nonTissueFiles.length > 0) {
            yield put(
                setPONonTissueImageDetails(
                    existingNonTissueImages
                        ? `${existingNonTissueImages},${nonTissueFiles.join()}`
                        : nonTissueFiles.join()
                )
            );

            yield put(
                setShippingDetails({
                    ['payment']: existingNonTissueImages
                        ? `${existingNonTissueImages},${nonTissueFiles.join()}`
                        : nonTissueFiles.join(),
                    salesOrg: 'S002',
                    objParams: 'poAttachment',
                })
            );
            // yield put({
            //     type: EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
            //     payload: existingNonTissueImages
            //         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
            //         : nonTissueFiles.join(),
            // });
        }

        if (tissueFiles.length > 0) {
            yield put(
                setPOTissueImageDetails(
                    existingTissueImages
                        ? `${existingTissueImages},${tissueFiles.join()}`
                        : tissueFiles.join()
                )
            );
            yield put(
                setShippingDetails({
                    ['payment']: existingTissueImages
                        ? `${existingTissueImages},${tissueFiles.join()}`
                        : tissueFiles.join(),
                    salesOrg: 'S030',
                    objParams: 'poAttachment',
                })
            );
            // yield put({
            //     type: EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
            //     payload: existingTissueImages
            //         ? `${existingTissueImages},${tissueFiles.join()}`
            //         : tissueFiles.join(),
            // });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: usageAttachmentUploadEndpoint(),
            requestPayload: action.payload
        });
        yield put({
            type: EQUITY_USAGE_ATTACHMENT_UPLOAD_FAILURE,
            payload: {},
        });
    }
}

export function* deleteAttachmentSaga(action) {
    // const { existingTissueImages, existingNonTissueImages } = yield select(
    //     (state) => ({
    //         existingTissueImages:
    //             state.equityDetailsReducer?.poTissueImageDetails?.split(','),
    //         existingNonTissueImages:
    //             state.equityDetailsReducer?.poNonTissueImageDetails?.split(','),
    //     })
    // );
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.equityReducer?.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                ].payment.poAttachment.split(','),
            existingNonTissueImages:
                state.equityReducer?.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                ].payment.poAttachment.split(','),
        })
    );
    try {
        const response = yield deleteAttachmentFunc(action.payload);
        if (response.status) {
            const { fileName, isTissue } = action.payload;

            if (isTissue) {
                const deletedImageIndex = existingTissueImages.findIndex(
                    (extImg) => extImg === fileName
                );
                existingTissueImages.splice(deletedImageIndex, 1);
            } else {
                const deletedImageIndex = existingNonTissueImages.findIndex(
                    (exntImg) => exntImg === fileName
                );
                existingNonTissueImages.splice(deletedImageIndex, 1);
            }
            yield put({
                type: EQUITY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
                payload: {
                    isTissue,
                    imagesToBeUpdated: isTissue
                        ? existingTissueImages.join()
                        : existingNonTissueImages.join(),
                },
            });
            yield put(
                setShippingDetails({
                    ['payment']: isTissue
                        ? existingTissueImages.join()
                        : existingNonTissueImages.join(),
                    salesOrg: isTissue
                        ? TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                        : TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
                    objParams: 'poAttachment',
                })
            );
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: deleteAttachmentEndpoint(action.payload.fileName),
            requestPayload: action.payload
        });
        yield put({
            type: EQUITY_DELETE_ATTACHMENT_REQUEST_FAILURE,
            payload: {},
        });
    }
}
export function* getImagePoPreviewSaga(action) {
    try {
        const response = yield getImagePoPreviewFunc(action.payload);
        if (response.status) {
            yield put({
                type: EQUITY_GET_IMAGE_PO_PREVIEW_SUCCESS,
                payload: response.data.attachment,
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getImagePoPreviewEndpoint(action.payload.fileName),
            requestPayload: action.payload
        });
        yield put({
            type: EQUITY_GET_IMAGE_PO_PREVIEW_FAILURE,
            payload: {},
        });
    }
}
